import type { Path } from '@exam-management/router';
import {
  CalendarTodayOutlinedIcon,
  Divider,
  Flex,
  PersonOutlinedIcon,
  Text,
} from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { QSetReviewHistoryCardItem } from '../qset-review-history-card-item';

export interface QSetReviewHistoryItemProps {
  taskId: string;
  taskName: string;
  assignedAt: Date;
  assignerName: string;
  reviewers: {
    id: string;
    name: string;
    assignedAt: Date;
    submittedAt: Date | null;
    detailsPath?: Path;
  }[];
}

export default function QSetReviewHistoryItem(props: Readonly<QSetReviewHistoryItemProps>) {
  const { taskId, taskName, assignedAt, assignerName, reviewers } = props;
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(6),
        gap: theme.spacing(4),
        border: `1px solid ${theme.palette.grey[300]}`,
      })}
    >
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(3),
        })}
      >
        <Text variant='h5'>Task Name: {taskName}</Text>
        <Flex sx={(theme) => ({ gap: theme.spacing(4), color: theme.palette.text.secondary })}>
          <Text
            variant='body2'
            sx={(theme) => ({ display: 'flex', alignItems: 'center', gap: theme.spacing(1) })}
          >
            <CalendarTodayOutlinedIcon
              sx={(theme) => ({ fontSize: theme.typography.body1.fontSize })}
            />
            Assignment Date: {formatDateTime(assignedAt)}
          </Text>
          <Text
            variant='body2'
            sx={(theme) => ({ display: 'flex', alignItems: 'center', gap: theme.spacing(1) })}
          >
            <PersonOutlinedIcon sx={(theme) => ({ fontSize: theme.typography.body1.fontSize })} />
            Assigner: {assignerName}
          </Text>
        </Flex>
      </Flex>
      <Divider />
      <Text variant='h5'>Reviewer</Text>
      {reviewers.map((reviewer) => (
        <QSetReviewHistoryCardItem
          key={`${reviewer.name}-${reviewer.assignedAt.toISOString()}`}
          taskId={taskId}
          subtaskId={reviewer.id}
          assigneeName={reviewer.name}
          assignedAt={reviewer.assignedAt}
          submittedAt={reviewer.submittedAt}
          detailsPath={reviewer.detailsPath}
        />
      ))}
    </Flex>
  );
}
